import React, { useState } from 'react';
import { Search, HelpCircle, Settings, ChevronLeft, ChevronRight, Home, Eye, Edit2, PlayCircle, Filter, ChevronDown, User, Phone, CheckCircle, XCircle, Clock, FileText, MapPin, Hash, Calendar, Layout, Info } from 'lucide-react';

const ManageForms = () => {
    const [view, setView] = useState('list'); // 'list' | 'detail'
    const [selectedForm, setSelectedForm] = useState(null);

    const handleFormClick = (form) => {
        setSelectedForm(form);
        setView('detail');
    };

    const handleBack = () => {
        setSelectedForm(null);
        setView('list');
    };

    return (
        <div style={ { padding: '0', marginTop: '-24px', marginBottom: '-24px', fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif', background: '#f9fafb', minHeight: '85vh', display: 'flex', flexDirection: 'column' } }>
            { view === 'list' ? (
                <ListView onFormClick={ handleFormClick } />
            ) : (
                <DetailView form={ selectedForm } onBack={ handleBack } />
            ) }
        </div>
    );
};

// --- DATA ---
const MOCK_FORMS = [
    { id: 'F2', name: 'Sales Team Follow Up', type: 'Primary', status: 'Published', modifiedBy: 'Siddharth Jain', modifiedOn: '06/01/2026 04:10 PM' },
    { id: 'F5', name: 'Due Diligence', type: 'Primary', status: 'Published', modifiedBy: 'Siddharth Jain', modifiedOn: '06/01/2026 02:35 PM' },
    { id: 'F8', name: 'Initial Call / Follow Up', type: 'Primary', status: 'Published', modifiedBy: 'Siddharth Jain', modifiedOn: '10/10/2025 10:57 AM' },
    { id: 'F1', name: 'Add New Lead', type: 'Primary', status: 'Published', modifiedBy: 'Siddharth Jain', modifiedOn: '05/09/2025 11:16 AM' },
    { id: 'F11', name: 'New Enquiry Form', type: 'Primary', status: 'Published', modifiedBy: 'System', modifiedOn: '14/05/2025 04:20 PM' },
    { id: 'F4', name: 'Document Collection', type: 'Primary', status: 'Published', modifiedBy: 'Tech', modifiedOn: '11/04/2025 12:30 PM' },
    { id: 'F10', name: 'Welcome - Onboarding Call', type: 'Primary', status: 'Published', modifiedBy: 'System', modifiedOn: '20/03/2025 07:44 AM' },
    { id: 'F6', name: 'Booking', type: 'Primary', status: 'Published', modifiedBy: 'System', modifiedOn: '20/03/2025 07:32 AM' },
    { id: 'F3', name: 'Demo', type: 'Primary', status: 'Published', modifiedBy: 'System', modifiedOn: '20/03/2025 05:05 AM' },
    { id: 'F7', name: 'Share Lead', type: 'Primary', status: 'Published', modifiedBy: 'System', modifiedOn: '08/03/2025 01:30 PM' },
];

const FORM_FIELDS = {
    "Lead and Enquiry Details": [
        { icon: <User size={ 14 } />, label: "First Name", type: "text" },
        { icon: <Phone size={ 14 } />, label: "Phone Number", type: "text" },
        { icon: <Layout size={ 14 } />, label: "Opportunity Name", type: "text" },
        { icon: <Info size={ 14 } />, label: "Status", type: "dropdown" },
        { icon: <Layout size={ 14 } />, label: "Stage", type: "dropdown" },
        { icon: <User size={ 14 } />, label: "Owner", type: "user" },
    ],
    "Sales Team Follow Up Details": [
        { icon: <Phone size={ 14 } />, label: "Call Status", type: "dropdown" },
        { icon: <CheckCircle size={ 14 } />, label: "Connected - Outcome", type: "dropdown" },
        { icon: <XCircle size={ 14 } />, label: "Not Connected - Outcome", type: "dropdown" },
        { icon: <HelpCircle size={ 14 } />, label: "Not Responding - Outcome", type: "dropdown" },
        { icon: <Phone size={ 14 } />, label: "Wrong Number - Outcome", type: "dropdown" },
        { icon: <Calendar size={ 14 } />, label: "Demo Scheduled - Date and Time", type: "datetime" },
    ],
    "Mail Merge Fields": [
        { icon: <Hash size={ 14 } />, label: "Aadhaar (A)", type: "text" },
        { icon: <Layout size={ 14 } />, label: "Asset Category (A)", type: "text" },
        { icon: <Layout size={ 14 } />, label: "Asset Type (A)", type: "text" },
        { icon: <FileText size={ 14 } />, label: "Driving License (A)", type: "text" },
        { icon: <Layout size={ 14 } />, label: "Driving License Status (A)", type: "dropdown" },
        { icon: <Layout size={ 14 } />, label: "Existing Vehicle (A)", type: "dropdown" },
        { icon: <Calendar size={ 14 } />, label: "Expected Date of Permanent DL (A)", type: "date" },
        { icon: <Hash size={ 14 } />, label: "Number of Vehicle Requirement (A)", type: "number" },
        { icon: <Layout size={ 14 } />, label: "On - Road (A)", type: "text" },
        { icon: <Hash size={ 14 } />, label: "PAN (A)", type: "text" },
    ]
};

// --- LIST VIEW ---
const ListView = ({ onFormClick }) => {
    return (
        <div style={ { padding: '24px', flex: 1, display: 'flex', flexDirection: 'column' } }>
            <div style={ { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' } }>
                <h1 style={ { fontSize: '20px', fontWeight: 600, color: '#374151', margin: 0 } }>Manage Forms</h1>
                <HelpCircle size={ 16 } color="#9ca3af" />
            </div>

            {/* Search */ }
            <div style={ { marginBottom: '16px', display: 'flex' } }>
                <div style={ { position: 'relative', width: '250px' } }>
                    <input type="text" placeholder="Search Forms" style={ { width: '100%', padding: '8px 30px 8px 10px', border: '1px solid #d1d5db', borderRadius: '4px 0 0 4px', fontSize: '13px', outline: 'none' } } />
                    <Search size={ 14 } style={ { position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' } } />
                </div>
                <button style={ { border: '1px solid #d1d5db', borderLeft: 'none', background: '#f9fafb', padding: '0 10px', borderRadius: '0 4px 4px 0', cursor: 'pointer' } }>
                    <Search size={ 14 } color="#6b7280" />
                </button>
            </div>

            {/* Filter Bar */ }
            <div style={ { background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '4px', padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '0' } }>
                <div style={ { position: 'relative' } }>
                    <input type="text" placeholder="Filter by Tag" style={ { width: '100%', padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px' } } />
                </div>
                <div style={ { display: 'flex', gap: '15px', flexWrap: 'wrap' } }>
                    { ['Status', 'Type', 'Modified By', 'Modified On'].map(label => (
                        <div key={ label } style={ { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#374151' } }>
                            <span style={ { fontWeight: 600 } }>{ label }</span>
                            <div style={ { background: '#fff', border: '1px solid #d1d5db', borderRadius: '3px', padding: '4px 8px', display: 'flex', alignItems: 'center', gap: '20px', cursor: 'pointer', minWidth: '80px', justifyContent: 'space-between' } }>
                                { label === 'Status' ? 'Published' : label === 'Modified By' ? 'Any' : 'All' } <ChevronDown size={ 12 } color="#6b7280" />
                            </div>
                        </div>
                    )) }
                </div>
            </div>

            {/* Table */ }
            <div style={ { background: '#fff', border: '1px solid #e5e7eb', borderTop: 'none', borderRadius: '0 0 4px 4px', overflowX: 'auto' } }>
                <table style={ { width: '100%', borderCollapse: 'collapse', fontSize: '13px', minWidth: '800px' } }>
                    <thead>
                        <tr style={ { background: '#e5e7eb', color: '#374151', textAlign: 'left' } }>
                            <th style={ { padding: '10px 16px', fontWeight: 600 } }>Form Id</th>
                            <th style={ { padding: '10px 16px', fontWeight: 600 } }>Name</th>
                            <th style={ { padding: '10px 16px', fontWeight: 600, textAlign: 'center' } }></th>
                            <th style={ { padding: '10px 16px', fontWeight: 600 } }>Type</th>
                            <th style={ { padding: '10px 16px', fontWeight: 600 } }>Status</th>
                            <th style={ { padding: '10px 16px', fontWeight: 600 } }>Modified By</th>
                            <th style={ { padding: '10px 16px', fontWeight: 600 } }>Modified On <ChevronDown size={ 10 } style={ { display: 'inline' } } /></th>
                            <th style={ { padding: '10px 16px', fontWeight: 600 } }>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { MOCK_FORMS.map((form, i) => (
                            <tr key={ form.id } style={ { borderBottom: '1px solid #f3f4f6', background: i === 0 ? '#fff7ed' : '#fff' } }>
                                <td style={ { padding: '12px 16px', color: '#6b7280' } }>{ form.id }</td>
                                <td style={ { padding: '12px 16px' } }>
                                    <span
                                        onClick={ () => onFormClick(form) }
                                        style={ { color: '#2563eb', cursor: 'pointer', fontWeight: 500 } }
                                        onMouseEnter={ (e) => e.target.style.textDecoration = 'underline' }
                                        onMouseLeave={ (e) => e.target.style.textDecoration = 'none' }
                                    >
                                        { form.name }
                                    </span>
                                </td>
                                <td style={ { padding: '12px 16px', textAlign: 'center' } }>
                                    <Eye size={ 14 } color="#9ca3af" />
                                </td>
                                <td style={ { padding: '12px 16px', color: '#6b7280' } }>{ form.type }</td>
                                <td style={ { padding: '12px 16px', color: '#6b7280' } }>{ form.status }</td>
                                <td style={ { padding: '12px 16px', color: '#6b7280' } }>{ form.modifiedBy }</td>
                                <td style={ { padding: '12px 16px', color: '#6b7280' } }>{ form.modifiedOn }</td>
                                <td style={ { padding: '12px 16px' } }>
                                    <Settings size={ 16 } color="#9ca3af" style={ { cursor: 'pointer' } } />
                                </td>
                            </tr>
                        )) }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// --- DETAIL VIEW ---
const DetailView = ({ form, onBack }) => {
    return (
        <div style={ { display: 'flex', flexDirection: 'column', flex: 1, height: '100%' } }>
            {/* Top Toolbar */ }
            <div style={ { background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '0 20px', height: '56px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } }>
                <div style={ { display: 'flex', alignItems: 'center', gap: '16px' } }>
                    <button onClick={ onBack } style={ { border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 } }>
                        <Home size={ 18 } color="#6b7280" />
                    </button>
                    <div style={ { display: 'flex', alignItems: 'center', gap: '8px' } }>
                        <div style={ { width: '8px', height: '8px', borderRadius: '50%', background: '#22c55e' } }></div>
                        <span style={ { fontWeight: 600, fontSize: '14px', color: '#1f2937' } }>{ form?.name || 'Sales Team Follow Up' }</span>
                    </div>
                    <Settings size={ 16 } color="#9ca3af" style={ { cursor: 'pointer' } } />
                </div>

                <div style={ { display: 'flex', alignItems: 'center', gap: '4px', background: '#f3f4f6', padding: '2px', borderRadius: '4px' } }>
                    <button style={ { border: 'none', background: '#2563eb', color: '#fff', fontSize: '12px', fontWeight: 500, padding: '4px 16px', borderRadius: '4px', cursor: 'pointer' } }>Design</button>
                    <button style={ { border: 'none', background: 'transparent', color: '#6b7280', fontSize: '12px', fontWeight: 500, padding: '4px 16px', borderRadius: '4px', cursor: 'pointer' } }>Rules</button>
                </div>

                <div style={ { display: 'flex', alignItems: 'center', gap: '10px' } }>
                    <div style={ { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#2563eb', cursor: 'pointer', marginRight: '10px' } }>
                        <Eye size={ 14 } /> Preview
                    </div>
                    <button style={ { background: '#f97316', border: 'none', color: '#fff', fontSize: '13px', fontWeight: 500, padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' } }>Live Edit</button>
                    <button style={ { background: '#2563eb', border: 'none', color: '#fff', fontSize: '13px', fontWeight: 500, padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' } }>Unpublish</button>
                </div>
            </div>

            {/* Main Content Area */ }
            <div style={ { display: 'flex', flex: 1, overflow: 'hidden' } }>

                {/* Canvas (Left) */ }
                <div style={ { flex: 1, background: '#f9fafb', padding: '24px', overflowY: 'auto' } }>
                    <div style={ { background: '#fff', border: '1px solid #e5e7eb', borderRadius: '4px', maxWidth: '800px', margin: '0 0' } }>

                        {/* Form Title Block */ }
                        <div style={ { padding: '20px 24px', borderBottom: '1px solid #e5e7eb' } }>
                            <h2 style={ { fontSize: '18px', fontWeight: 600, margin: '0 0 4px 0', color: '#111827' } }>{ form?.name || 'Sales Team Follow Up' }</h2>
                            <div style={ { fontSize: '13px', color: '#9ca3af' } }>Form Description (Optional)</div>
                        </div>

                        {/* Tabs inside Canvas */ }
                        <div style={ { display: 'flex', borderBottom: '1px solid #e5e7eb' } }>
                            <div style={ { padding: '12px 24px', borderBottom: '2px solid #2563eb', color: '#2563eb', fontSize: '13px', fontWeight: 500, cursor: 'pointer' } }>All Details</div>
                            <div style={ { padding: '12px 24px', color: '#6b7280', fontSize: '13px', fontWeight: 500, cursor: 'pointer' } }>Requirements</div>
                            <div style={ { flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '10px' } }>
                                <ChevronRight size={ 16 } color="#9ca3af" />
                            </div>
                        </div>

                        {/* Sections & Fields */ }
                        <div style={ { padding: '24px' } }>
                            { Object.entries(FORM_FIELDS).map(([sectionTitle, fields], idx) => (
                                <div key={ idx } style={ { marginBottom: '30px', border: idx === 0 ? '1px dashed #d1d5db' : 'none', padding: idx === 0 ? '16px' : '0' } }>
                                    <div style={ { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', cursor: 'pointer' } }>
                                        <ChevronDown size={ 16 } color="#2563eb" />
                                        <span style={ { color: '#2563eb', fontSize: '14px', fontWeight: 500 } }>{ sectionTitle }</span>
                                    </div>

                                    <div style={ { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px 40px' } }>
                                        { fields.map((field, fIdx) => (
                                            <div key={ fIdx } style={ { display: 'flex', alignItems: 'flex-start', gap: '10px' } }>
                                                <div style={ { marginTop: '3px', color: '#9ca3af' } }>{ field.icon }</div>
                                                <div style={ { flex: 1 } }>
                                                    <div style={ { fontSize: '13px', color: '#4b5563', marginBottom: '4px' } }>{ field.label }</div>
                                                    <div style={ { fontSize: '12px', color: '#9ca3af', fontStyle: 'italic', borderBottom: '1px dotted #e5e7eb', paddingBottom: '4px', cursor: 'pointer' } }>Click to configure</div>
                                                </div>
                                            </div>
                                        )) }
                                    </div>
                                </div>
                            )) }
                        </div>

                    </div>
                </div>

                {/* Sidebar (Right) */ }
                <div style={ { width: '300px', background: '#fff', borderLeft: '1px solid #e5e7eb', padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' } }>
                    <div style={ { fontSize: '14px', fontWeight: 600, color: '#111827', marginBottom: '10px' } }>Form Properties</div>

                    <div>
                        <label style={ { display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '6px' } }>Title <HelpCircle size={ 10 } style={ { display: 'inline' } } /></label>
                        <input type="text" defaultValue={ form?.name || 'Sales Team Follow Up' } style={ { width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px' } } />
                    </div>

                    <div>
                        <label style={ { display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '6px' } }>Description <FileText size={ 10 } style={ { display: 'inline' } } /></label>
                        <textarea rows={ 3 } style={ { width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', resize: 'none' } } />
                    </div>

                    <div>
                        <label style={ { display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '6px' } }>Help Text</label>
                        <input type="text" style={ { width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', borderBottom: '1px solid #e5e7eb' } } />
                    </div>

                    <div>
                        <label style={ { display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '6px' } }>Help URL</label>
                        <input type="text" style={ { width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', borderBottom: '1px solid #e5e7eb' } } />
                    </div>

                    <div>
                        <label style={ { display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '6px' } }>Logo</label>
                        <button style={ { width: '100%', padding: '8px', border: '1px solid #e5e7eb', background: '#f3f4f6', borderRadius: '4px', fontSize: '13px', color: '#374151', cursor: 'pointer' } }>Choose File</button>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default ManageForms;
